module.exports = __webpack_public_path__ + "images/content/product_features.gif";